<template>
    <div class="admin-pagination-record" v-if="records && records.total">
        <div class="admin-pagination-record__summary">
            {{ recordSummary }}
        </div>
        <div class="admin-pagination-record__controls">
            <nav class="admin-pagination-record__pages" :aria-label="trans('general.pagination') || 'Pagination'">
                <ul class="pagination mb-0">
                    <li class="page-item pagination-prev-nav" :class="{ disabled: !hasPrev }">
                        <a
                            class="page-link"
                            href="#"
                            :aria-label="trans('general.previous') || 'Previous'"
                            :tabindex="hasPrev ? undefined : -1"
                            @click.prevent="goTo(currentPage - 1)"
                        >
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    <li
                        v-for="(page, key) in pageRange"
                        :key="'page-' + key"
                        class="page-item pagination-page-nav"
                        :class="{ active: page === currentPage, disabled: page === '...' }"
                    >
                        <a
                            class="page-link"
                            href="#"
                            :aria-current="page === currentPage ? 'page' : null"
                            :tabindex="page === '...' ? -1 : undefined"
                            @click.prevent="goTo(page)"
                        >
                            {{ page }}
                        </a>
                    </li>
                    <li class="page-item pagination-next-nav" :class="{ disabled: !hasNext }">
                        <a
                            class="page-link"
                            href="#"
                            :aria-label="trans('general.next') || 'Next'"
                            :tabindex="hasNext ? undefined : -1"
                            @click.prevent="goTo(currentPage + 1)"
                        >
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
            <div class="admin-pagination-record__length-control">
                <select
                    name="page_length"
                    class="form-control admin-pagination-record__select"
                    :value="pageLength"
                    :aria-label="trans('general.per_page')"
                    @change="updateValue"
                >
                    <option
                        v-for="option in getConfig('pagination')"
                        :key="option"
                        v-bind:value="option"
                    >
                        {{ option+' '+trans('general.per_page') }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		props:['pageLength','records'],
		computed: {
			meta() {
				const records = this.records || {};
				return records.meta || records;
			},
			currentPage() {
				return Number(this.meta.current_page) || 1;
			},
			lastPage() {
				return Number(this.meta.last_page) || 1;
			},
			from() {
				return this.meta.from != null ? this.meta.from : 0;
			},
			to() {
				return this.meta.to != null ? this.meta.to : 0;
			},
			total() {
				return Number(this.meta.total) || 0;
			},
			hasPrev() {
				return this.currentPage > 1;
			},
			hasNext() {
				return this.currentPage < this.lastPage;
			},
			recordSummary() {
				const key = 'general.showing_records';
				const translated = this.trans(key, {
					from: this.from,
					to: this.to,
					total: this.total
				});
				if (translated && translated !== key) {
					return translated;
				}
				return 'Showing ' + this.from + ' to ' + this.to + ' of ' + this.total + ' records';
			},
			pageRange() {
				const last = this.lastPage;
				const current = this.currentPage;
				const delta = 2;
				const range = [];
				const pages = [];
				let l;

				for (let i = 1; i <= last; i++) {
					if (i === 1 || i === last || (i >= current - delta && i <= current + delta)) {
						range.push(i);
					}
				}

				range.forEach(function (i) {
					if (l) {
						if (i - l === 2) {
							pages.push(l + 1);
						} else if (i - l !== 1) {
							pages.push('...');
						}
					}
					pages.push(i);
					l = i;
				});

				return pages.length ? pages : [1];
			}
		},
		methods: {
			getConfig(config){
				return helper.getConfig(config);
			},
            updateValue(e){
                this.$emit('update:pageLength',e.target.value);
            },
            goTo(page){
            	if (page === '...' || page < 1 || page > this.lastPage || page === this.currentPage) {
            		return;
            	}
            	this.$emit('updateRecords', page);
            }
		}
	}
</script>
